import React from 'react';
export function PrivacyPolicy() {
  return <section className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-528">
      <div className="max-w-3xl mx-auto" data-id="element-529">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-530">
          Privacy Policy
        </h1>
        <p className="text-white/40 text-sm mb-12" data-id="element-531">
          Last updated: January 2025
        </p>

        <div className="space-y-8 text-white/80 leading-relaxed" data-id="element-532">
          <div data-id="element-533">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-534">
              1. Introduction
            </h2>
            <p data-id="element-535">
              Welcome to aiwebsitepackage.com ("we", "our", "us"). We are
              committed to protecting your personal information and your right
              to privacy. This Privacy Policy explains what information we
              collect, how we use it, and what rights you have in relation to
              it.
            </p>
          </div>

          <div data-id="element-536">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-537">
              2. Information We Collect
            </h2>
            <p className="mb-3" data-id="element-538">
              We only collect information that you voluntarily provide to us
              through our contact form or direct messaging, including:
            </p>
            <ul className="list-disc list-inside space-y-1 text-white/70 ml-4" data-id="element-539">
              <li data-id="element-540">Your name</li>
              <li data-id="element-541">Email address or WhatsApp number</li>
              <li data-id="element-542">Business type</li>
              <li data-id="element-543">Current website URL (if provided)</li>
              <li data-id="element-544">Any message or details you share with us</li>
            </ul>
          </div>

          <div data-id="element-545">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-546">
              3. How We Use Your Information
            </h2>
            <p className="mb-3" data-id="element-547">We use the information we collect solely to:</p>
            <ul className="list-disc list-inside space-y-1 text-white/70 ml-4" data-id="element-548">
              <li data-id="element-549">Respond to your enquiries and quote requests</li>
              <li data-id="element-550">Deliver the website services you purchase</li>
              <li data-id="element-551">Communicate with you about your project</li>
              <li data-id="element-552">Provide ongoing support for your website</li>
            </ul>
          </div>

          <div data-id="element-553">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-554">
              4. We Do Not Sell or Share Your Data
            </h2>
            <p data-id="element-555">
              <strong className="text-white" data-id="element-556">
                We do not sell, rent, trade, or otherwise share your personal
                information with any third parties.
              </strong>{' '}
              Your data is used exclusively for providing our services to you.
              We will never share your contact details, business information, or
              any other personal data with advertisers, marketing companies, or
              any other external parties.
            </p>
          </div>

          <div data-id="element-557">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-558">
              5. Data Storage & Security
            </h2>
            <p data-id="element-559">
              We take reasonable measures to protect your personal information.
              Form submissions are sent directly to our email and are not stored
              in any public database. We use secure communication channels
              (WhatsApp, LINE, email) for all client interactions.
            </p>
          </div>

          <div data-id="element-560">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-561">
              6. Third-Party Services
            </h2>
            <p data-id="element-562">
              Our website may use third-party services such as FormSubmit for
              form delivery and analytics tools for basic traffic monitoring.
              These services have their own privacy policies and we encourage
              you to review them. We do not pass any personal data to these
              services beyond what is necessary for their function.
            </p>
          </div>

          <div data-id="element-563">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-564">
              7. Your Rights
            </h2>
            <p className="mb-3" data-id="element-565">You have the right to:</p>
            <ul className="list-disc list-inside space-y-1 text-white/70 ml-4" data-id="element-566">
              <li data-id="element-567">Request access to the personal data we hold about you</li>
              <li data-id="element-568">Request correction or deletion of your personal data</li>
              <li data-id="element-569">Withdraw consent for us to contact you at any time</li>
            </ul>
            <p className="mt-3" data-id="element-570">
              To exercise any of these rights, simply contact us at{' '}
              <span className="text-[#c9a84c]" data-id="element-571">nmservicesww@gmail.com</span>.
            </p>
          </div>

          <div data-id="element-572">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-573">
              8. Changes to This Policy
            </h2>
            <p data-id="element-574">
              We may update this Privacy Policy from time to time. Any changes
              will be reflected on this page with an updated date. We encourage
              you to review this policy periodically.
            </p>
          </div>

          <div data-id="element-575">
            <h2 className="text-xl font-bold text-white mb-3" data-id="element-576">9. Contact Us</h2>
            <p data-id="element-577">
              If you have any questions about this Privacy Policy, please
              contact us at:
              <br data-id="element-578" />
              <span className="text-[#c9a84c]" data-id="element-579">nmservicesww@gmail.com</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}